import { copy as sharedUiCopy } from '@shared/copy';
import { Skeleton, SkeletonHead, SkeletonMetaGrid } from '@shared/ui/Skeleton';

/**
 * The pending state of `/users/:userId`.
 *
 * The surface is a head and then a run of `DetailSection`s, and the placeholder
 * is the same: each section opens on its heading with one action pushed to the
 * reading end, and each carries the panel its own facts sit in. That heading
 * row is drawn rather than skipped — it arrives with the payload, so leaving it
 * out drops three headings and three buttons into the page under the operator's
 * eye.
 *
 * THREE sections, which is the count every account has: the profile, the roles
 * and the entitlements. The biography section is conditional on the account
 * holding a role, and the case history is a table whose own read has not been
 * asked for yet — neither is reserved, because a placeholder for a section that
 * may never render is a gap that collapses on arrival.
 */
function SectionSkeleton({ rows }: { readonly rows: number }) {
  return (
    <section aria-hidden="true" className="mt-section-gap first:mt-0">
      <div className="mb-4 flex flex-wrap items-center gap-x-3 gap-y-2">
        <Skeleton className="h-7 w-[9rem]" />
        <Skeleton className="ms-auto h-6 w-[6rem] rounded-sm" />
      </div>

      <SkeletonMetaGrid rows={rows} />
    </section>
  );
}

export function UserDetailSkeleton() {
  return (
    <>
      <p role="status" className="sr-only">
        {sharedUiCopy.state.loading}
      </p>

      <SkeletonHead />

      <SectionSkeleton rows={5} />
      <SectionSkeleton rows={2} />
      <SectionSkeleton rows={3} />
    </>
  );
}
